import React from 'react'
import { useDispatch } from 'react-redux'
import { Grid, Link, Paper, Theme, Typography, useMediaQuery } from '@mui/material'
import { MenuItem } from '../../../screens/App/App'
import * as settingsActions from '../../../store/settings/settings.actions'
import { makeStyles } from '@mui/styles'
import { useHistory } from 'react-router-dom'
import { getAppTheme } from '../../../shared/config/getAppTheme'
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos'

const useStyles = makeStyles((theme: Theme) => ({
  dashboardImage: {
    width: '100%',
    height: 'auto',
  },
}))

const DashboardComponent = () => {
  const dispatch = useDispatch()
  const history = useHistory()
  const classes = useStyles()
  const theme: Theme = getAppTheme()
  const downSm = useMediaQuery(theme.breakpoints.down('sm'))
  const downMd = useMediaQuery(theme.breakpoints.down('md'))

  const handleNavigation = (section: string, geography?: string) => {
    dispatch(settingsActions.setNavPoint([MenuItem.family, section]))
    if (geography) {
      dispatch(settingsActions.setGeography(geography))
    }
    history.replace(`/${MenuItem.family}/${section}`)
  }

  const linkStyle = {
    cursor: 'pointer',
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
  }

  const iconStyle = {
    width: '15px',
    height: '15px',
    color: theme.palette.primary.main,
    marginLeft: '10px',
    marginTop: '-3px',
  }

  const mobileLinkContainerStyle = {
    display: 'flex',
    alignItems: 'center',
    paddingTop: '0!important',
    cursor: 'pointer',
  }

  return (
    <Paper sx={{ margin: downSm ? '0px' : '32px', padding: downSm ? '8px' : '32px' }}>
      <Typography variant='h1'>Familie Meißner</Typography>
      <Typography variant='subtitle1'>Skat - Eine Tradition, die verbindet</Typography>
      <Grid container spacing={3}>
        <Grid item xs={downMd ? 12 : 6}>
          <Typography variant='body1'>
            In dem malerischen Dorf Niederstaucha, tief verwurzelt im Herzen Sachsens, begann eine
            bemerkenswerte Familiengeschichte, die Generationen von Menschen in ihren Bann zog. Das Jahr war
            1879, als Otto Meissner das Licht der Welt erblickte und somit den Grundstein für eine
            Geschichte legte, die von Liebe, Hingabe und unermüdlichem Streben nach einem besseren Leben
            geprägt war. Die Meißner-Familie sollte durch die Wirren der Zeit gehen, die Herausforderungen
            des 20. Jahrhunderts meistern und schließlich ein Erbe hinterlassen, das bis heute weit über die
            Grenzen von Niederstaucha hinaus lebendig ist. Tauchen wir ein in die faszinierende Chronik
            unserer Familie, die die Vergangenheit ehrt und die Zukunft gestaltet.
          </Typography>
        </Grid>
        <Grid item xs={downMd ? 12 : 6}>
          <Typography variant='body1'>
            Die Familie Meißner ist ein lebendiges Beispiel für generationsübergreifenden Zusammenhalt und
            die Macht einer gemeinsamen Tradition. Seit Jahren versammelt sich die Familie jedes Jahr, um
            sich bei einem Skat-Turnier zu messen. Diese jahrzehntelange Tradition hat nicht nur ihre Liebe
            zum Kartenspiel bewahrt, sondern auch die familiären Bande weiter gestärkt. Das Jahr 1981
            markiert den Beginn dieser Tradition, die bis heute anhält. Was als ungezwungene Zusammenkunft
            begann, entwickelte sich rasch zu einem jährlichen Highlight im Familienkalender. Die
            Begeisterung für das Kartenspiel verbindet die Familie, und das Turnier wurde zu einer
            Gelegenheit, bei der Großeltern, Eltern, Kinder und Enkel die Zeit miteinander genießen können.
          </Typography>
        </Grid>

        {/* Niederstaucha Section */}
        <Grid item xs={downSm ? 6 : 4}>
          <Link
            sx={linkStyle}
            underline='hover'
            onClick={() => handleNavigation('niederstaucha', 'niederstaucha')}
          >
            <img
              src='/images/niederstaucha-schloss.jpg'
              className={classes.dashboardImage}
              alt='Niederstaucha Schloss'
              style={{ filter: 'sepia(0.2)' }}
            />
          </Link>
        </Grid>
        {downSm && (
          <Grid item xs={6} sx={mobileLinkContainerStyle}>
            <Link
              sx={linkStyle}
              underline='hover'
              onClick={() => handleNavigation('niederstaucha', 'niederstaucha')}
            >
              <Typography variant='body1' sx={{ color: theme.palette.primary.main }}>
                Niederstaucha
              </Typography>
              <ArrowForwardIosIcon sx={iconStyle} />
            </Link>
          </Grid>
        )}

        {/* Otto Meissner Section */}
        <Grid item xs={downSm ? 6 : 4}>
          <Link
            sx={linkStyle}
            underline='hover'
            onClick={() => {
              dispatch(settingsActions.setBiography('ottoMeissner'))
              handleNavigation('ottoMeissner')
            }}
          >
            <img
              src='/images/biography.jpg'
              className={classes.dashboardImage}
              alt='Otto Meißner'
              style={{ filter: 'sepia(0.6) brightness(90%)', border: '1px solid lightgrey' }}
            />
          </Link>
        </Grid>
        {downSm && (
          <Grid item xs={6} sx={mobileLinkContainerStyle}>
            <Link
              sx={linkStyle}
              underline='hover'
              onClick={() => {
                dispatch(settingsActions.setBiography('ottoMeissner'))
                handleNavigation('ottoMeissner')
              }}
            >
              <Typography variant='body1' sx={{ color: theme.palette.primary.main }}>
                Otto Meißner
              </Typography>
              <ArrowForwardIosIcon sx={iconStyle} />
            </Link>
          </Grid>
        )}

        {/* Leipzig Section */}
        <Grid item xs={downSm ? 6 : 4}>
          <Link
            sx={linkStyle}
            underline='hover'
            onClick={() => handleNavigation('leipzig', 'leipzig')}
          >
            <img
              src='/images/Leipzig1911.jpg'
              className={classes.dashboardImage}
              alt='Leipzig 1911'
            />
          </Link>
        </Grid>
        {downSm && (
          <Grid item xs={6} sx={mobileLinkContainerStyle}>
            <Link
              sx={linkStyle}
              underline='hover'
              onClick={() => handleNavigation('leipzig', 'leipzig')}
            >
              <Typography variant='body1' sx={{ color: theme.palette.primary.main }}>
                Garnison Leipzig
              </Typography>
              <ArrowForwardIosIcon sx={iconStyle} />
            </Link>
          </Grid>
        )}
      </Grid>
    </Paper>
  )
}

export default DashboardComponent
